import { MouseEvent, useCallback } from 'react';
import { useProject } from '@context/Project';

const useShiftClickGuard = () => {
  const { drawer } = useProject();

  return useCallback(
    (event: MouseEvent) => {
      if (!drawer || !event.shiftKey || event.button !== 0) return;

      const target = event.target as HTMLElement | null;

      if (!target?.closest('.react-flow__node-customNode')) return;

      event.stopPropagation();
      event.preventDefault();
    },
    [drawer],
  );
};

export default useShiftClickGuard;
